import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 4, overflowX: 'hidden' }}>
      <Box sx={{ '& .MuiTypography-root': { whiteSpace: 'pre-line', wordBreak: 'break-word', overflowWrap: 'break-word' } }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h4" component="div" gutterBottom>
            {t('PRIVACY_POLICY_TITLE')}
          </Typography>
        </Box>

        <Typography variant="subtitle1" paragraph>
          {t('PRIVACY_POLICY_INTRO')}
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_1_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_1_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_2_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P1')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P2')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P3')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P4')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P5')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P6')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P7')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P8')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P9')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_2_P10')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_3_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P1')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P2')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P3')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P4')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P5')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P6')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P7')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_3_P8')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_4_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_4_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_5_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_5_P1')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_5_P2')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_6_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_6_P1')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_6_P2')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_6_P3')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_6_P4')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_7_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_7_P1')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_7_P2')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_8_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_8_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_9_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_9_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_10_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_10_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_11_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_11_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_12_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_12_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {t('PRIVACY_SECTION_13_TITLE')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_SECTION_13_P1')}
          </Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography paragraph margin={0}>
            {t('PRIVACY_POLICY_CONTACT_1')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_POLICY_CONTACT_2')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_POLICY_CONTACT_3')}
          </Typography>
          <Typography paragraph margin={0}>
            {t('PRIVACY_POLICY_CONTACT_4')}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
